import React from 'react';
import { Navbar, Button, Badge } from 'react-bootstrap';
import { Menu, Bell, Mail } from 'lucide-react';
import profileImg from '../../../img/akash.jpg';
import '../css/MobileHeader.css';

const MobileHeader = ({ onMenuClick }) => {
  return (
    <Navbar fixed="top" className="mobile-header-modern d-md-none">
      <div className="mobile-header-container">
        <div className="mobile-header-left">
          <Button 
            variant="ghost" 
            className="menu-btn" 
            onClick={onMenuClick}
            aria-label="Open menu"
          >
            <Menu size={24} />
          </Button>
          <Navbar.Brand className="mobile-brand">✨ AdminHub</Navbar.Brand>
        </div>

        <div className="mobile-header-right">
          <Button variant="ghost" className="notification-btn" aria-label="Notifications">
            <Bell size={20} />
            <Badge pill bg="danger" className="notification-badge">5</Badge>
          </Button>
          <Button variant="ghost" className="notification-btn" aria-label="Messages">
            <Mail size={20} />
            <Badge pill bg="danger" className="notification-badge">3</Badge>
          </Button>
          <div className="mobile-profile-icon">
            <img src={profileImg} alt="Profile" className="mobile-profile-img" />
          </div>
        </div>
      </div>
    </Navbar>
  );
};

export default MobileHeader;